module.exports = __webpack_public_path__ + "img/news-section-image04.0774946e.png";